import { lazy } from 'react';
import { Routes } from './utils/renderRoutes';

const receiptRoutes: Routes[] = [
    {
        title: '小票',
        path: '/receipt',
        component: lazy(() => import('@/views/Receipt')),
        children: [
            {
                title: '小票审核',
                path: '/receipt/examine',
                component: lazy(() => import('@/views/Receipt/Examine')),
            },
            {
                title: '上传小票',
                path: '/receipt/upload',
                component: lazy(() => import('@/views/Receipt/Upload')),
            },
            {
                redirect: true,
                from: '/receipt',
                to: '/receipt/examine',
            },
        ],
    },
];
export default receiptRoutes;